import { useEffect, useRef, useState } from 'react'
const DEFAULT_ROOT_MARGIN = '200px'
export function useInViewOnce({ rootMargin = DEFAULT_ROOT_MARGIN, threshold = 0 } = {}) {
  const ref = useRef(null)
  const [seen, setSeen] = useState(false)
  useEffect(() => {
    if (seen) return
    const element = ref.current
    if (!element) return
    if (typeof IntersectionObserver === 'undefined') {
      setSeen(true)
      return
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setSeen(true)
          observer.disconnect()
        }
      },
      { rootMargin, threshold }
    )
    observer.observe(element)
    return () => observer.disconnect()
  }, [seen, rootMargin, threshold])
  return [ref, seen]
}
